import styles from "../dashboard/dashboard.module.scss";
import DashboardProperty from "../../stories/dashboard-properties";

const DashBoard = ({ type =  'agent' }: { type: string }) => {
  return (
    <div className={styles.dashboard}>
      <div className={styles.content}>
        {/* {arrRecentProperty?.length > 0 && ( */}
        <div className={styles.recentProperties}>
          {/* {loading ? (
              <ReactTableSkeleton />
            ) : ( */}
          <DashboardProperty
            type={type}
            // title={'Recent Properties'}
            // desc={`Showing ${arrRecentProperty?.length} Properties`}
            // loading={loading}
            // recentPropertyData={arrRecentProperty}
          />
          {/* )} */}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default DashBoard;
